<template>
    <div class="commute">
        
        <div>      
            <hr v-show="vehicle_gas" class="half spacer" /> 

            <div v-show="vehicle_gas"  class="bg fuel" id="energy_cost_fuel"  >
                <h1> 
                {{ $t('commute.title.fuel_gas_cost') }}
                </h1>
                   {{ convert('formatMoney','') }}
                   <ConvertedNumber
                   classes="money"
                   v-on:input="set('gas',$event)"  
                    :default_value="parseFloat(energy_costs['gas'])" 
                    :min=0 :max=300
                    :display_conversion="store_function('volume')"
                    :store_conversion="display_function('volume')"
                    :step=0.01
                    />
                   {{ $t('per') }} {{ settings('getVolumeUnit') }}
                   
                   <span v-if="!is_filled('gas')" class="red">
                     ({{ $t('field.required') }})
                    </span>
                     
            </div>

            <hr v-show="vehicle_diesel" class="half spacer" /> 

            <div v-show="vehicle_diesel"  class="bg fuel" id="energy_cost_fuel">
                <h1> 
                {{ $t('commute.title.fuel_diesel_cost') }}
                </h1>
                   {{ convert('formatMoney','') }}
                   <ConvertedNumber
                   classes="money"
                   v-on:input="set('diesel',$event)"  
                    :default_value="parseFloat(energy_costs['diesel'])" 
                    :min=0 :max=300
                    :display_conversion="store_function('volume')"
                    :store_conversion="display_function('volume')"
                    :step=0.01
                    
                    />
                   {{ $t('per') }} {{ settings('getVolumeUnit') }}
                   
                    <span v-if="!is_filled('diesel')" class="red">
                     ({{ $t('field.required') }})
                    </span>
                    
            </div>
            
            <hr v-show="vehicle_electric" class="half spacer" /> 

            <div v-show="vehicle_electric"  class="bg charge" id="energy_cost_electricity">
                <h1> 
                {{ $t('commute.title.electricity_cost') }}
                </h1>
                <p>
                    {{ $t('commute.title.electricity_cost_note') }} 
                </p>
                {{ convert('formatMoney','') }}
                <ConvertedNumber
                   classes="money"
                   v-on:input="set('electricity',$event)"  
                    :default_value="parseFloat(energy_costs['electricity'])" 
                    :min=0.0 :max=3
                    :step=0.01
                    />
                     {{ $t('per') }} {{ $t('units.electric.kwh') }}
                     
                     
                   <a target="_blank" :href="$t('commute.title.electricity_cost_helplink')" >{{ $t('commute.link.help') }}</a>
                   
                    <span v-if="!is_filled('electricity')" class="red">
                     ({{ $t('field.required') }})
                    </span>
                    
            </div>
        </div>
    </div>    
</template>

<script>
    import ConvertedNumber from './ConvertedNumber.vue'
    import conversions from '../conversions.js'
    import settings from '../settings.js'
    
    export default {
        components: {
            ConvertedNumber
        },
        data: function(){
            return {
                energy_costs : {},
            }
        },
        props: {
            commutes : Array,
            init_energy_costs : {}
        },
        
        created(){
            this.energy_costs = this.init_energy_costs
        },
        
        computed : {
            vehicle_gas : function(){
                for(let c in this.commutes){

                    if(['car', 'motorcycle'].includes(this.commutes[c].data.vehicle['vehicle'])){
                        if(['gas', 'hybrid'].includes(this.commutes[c].data.vehicle_costs['energy_source'])){
                            return true
                        }
                    }
                
                }
                return false
            },
            vehicle_diesel : function(){
                for(let c in this.commutes){

                    if(['car', 'motorcycle'].includes(this.commutes[c].data.vehicle['vehicle'])){
                        if(['diesel'].includes(this.commutes[c].data.vehicle_costs['energy_source'])){
                            return true
                        }
                    }
                
                }
                return false
            },
            
            vehicle_electric : function(){
                for(let c in this.commutes){
                    if(['car', 'motorcycle'].includes(this.commutes[c].data.vehicle['vehicle'])){
                        if(['electric'].includes(this.commutes[c].data.vehicle_costs['energy_source'])){
                            return true
                        }
                    }
                    if(['e-bicycle'].includes(this.commutes[c].data.vehicle['vehicle'])){
                        return true
                    }           
                }     
                return false
            },
            bootstrap_div_classes : function(){
                return "dbtn-group dbtn-group-toggle"
            },

        },
        methods: {
            set: function(k,v){
                this.$set(this.energy_costs, k, v)
                this.notify_parent()
            },
            notify_parent : function(){
                this.$emit('input', this.energy_costs)
            },
            convert: function(fn, ...args){
                return conversions[fn](...args);
            },
            is_filled: function(which){
                if(this.energy_costs[which] > 0){
                    return true
                }
                return false
            },
            display_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions['km2'+unit];
                    break;

                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }2
                        return conversions['l2'+unit];
                }
            },
            store_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2km']
                    break;
                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2l']
                }
            },
            settings : function(fn, ...args){
                return settings[fn](...args);
            }
        }
    }
    

</script>

<style>

</style>